import { FileFormField } from '../../../../../../File'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../../Formik'

import * as styles from './FileInput.module.css'

function FileInput({
  card: { label, name, required },
  fieldClassName,
  filesOptions,
}) {
  return (
    <FormikField
      Component={FileFormField}
      fieldComponentProps={{
        className: fieldClassName,
        label,
        required,
        shouldAdaptToMobileScreen: true,
      }}
      fileListItemClassName={styles.fileListItem}
      filesOptions={filesOptions}
      getErrorProps={getFormikFormFieldErrorProps}
      name={name}
      placeholder={label}
      uploadPlaceholderClassName={styles.uploadPlaceholder}
    />
  )
}

export default FileInput
